export const GET_ORGANIZATIONS_REQUEST = 'GET_ORGANIZATIONS_REQUEST';
export const GET_ORGANIZATIONS_SUCCESS = 'GET_ORGANIZATIONS_SUCCESS';
export const GET_ORGANIZATIONS_FAILED = 'GET_ORGANIZATIONS_FAILED';

export const GET_ORGANIZATION_REQUEST = 'GET_ORGANIZATION_REQUEST';
export const GET_ORGANIZATION_SUCCESS = 'GET_ORGANIZATION_SUCCESS';
export const GET_ORGANIZATION_FAILED = 'GET_ORGANIZATION_FAILED';

export const CREATE_ORGANIZATION_REQUEST = 'CREATE_ORGANIZATION_REQUEST';
export const CREATE_ORGANIZATION_SUCCESS = 'CREATE_ORGANIZATION_SUCCESS';
export const CREATE_ORGANIZATION_FAILED = 'CREATE_ORGANIZATION_FAILED';

export const UPDATE_ORGANIZATION_REQUEST = 'UPDATE_ORGANIZATION_REQUEST';
export const UPDATE_ORGANIZATION_SUCCESS = 'UPDATE_ORGANIZATION_SUCCESS';
export const UPDATE_ORGANIZATION_FAILED = 'UPDATE_ORGANIZATION_FAILED';

export const SEARCH_ORGANIZATION_REQUEST = 'SEARCH_ORGANIZATION_REQUEST';
export const SEARCH_ORGANIZATION_SUCCESS = 'SEARCH_ORGANIZATION_SUCCESS';
export const SEARCH_ORGANIZATION_FAILED = 'SEARCH_ORGANIZATION_FAILED';

export const SEARCH_ORGANIZATION_BY_URL_REQUEST = 'SEARCH_ORGANIZATION_BY_URL_REQUEST';
export const SEARCH_ORGANIZATION_BY_URL_SUCCESS = 'SEARCH_ORGANIZATION_BY_URL_SUCCESS';
export const SEARCH_ORGANIZATION_BY_URL_FAILED = 'SEARCH_ORGANIZATION_BY_URL_FAILED';

export const GET_ORGANIZATION_STATES_REQUEST = 'GET_ORGANIZATION_STATES_REQUEST';
export const GET_ORGANIZATION_STATES_SUCCESS = 'GET_ORGANIZATION_STATES_SUCCESS';
export const GET_ORGANIZATION_STATES_FAILED = 'GET_ORGANIZATION_STATES_FAILED';

export const GET_ORGANIZATION_STATISTICS_REQUEST = 'GET_ORGANIZATION_STATISTICS_REQUEST';
export const GET_ORGANIZATION_STATISTICS_SUCCESS = 'GET_ORGANIZATION_STATISTICS_SUCCESS';
export const GET_ORGANIZATION_STATISTICS_FAILED = 'GET_ORGANIZATION_STATISTICS_FAILED';

export const GET_GEO_CODE_REQUEST = 'GET_GEO_CODE_REQUEST';
export const GET_GEO_CODE_SUCCESS = 'GET_GEO_CODE_SUCCESS';
export const GET_GEO_CODE_FAILED = 'GET_GEO_CODE_FAILED';

export const GET_ORGANIZATION_SUBMISSION_REQUEST = 'GET_ORGANIZATION_SUBMISSION_REQUEST';
export const GET_ORGANIZATION_SUBMISSION_SUCCESS = 'GET_ORGANIZATION_SUBMISSION_SUCCESS';
export const GET_ORGANIZATION_SUBMISSION_FAILED = 'GET_ORGANIZATION_SUBMISSION_FAILED';

export const UPDATE_ORGANIZATION_SUBMISSION_REQUEST = 'UPDATE_ORGANIZATION_SUBMISSION_REQUEST';
export const UPDATE_ORGANIZATION_SUBMISSION_SUCCESS = 'UPDATE_ORGANIZATION_SUBMISSION_SUCCESS';
export const UPDATE_ORGANIZATION_SUBMISSION_FAILED = 'UPDATE_ORGANIZATION_SUBMISSION_FAILED';

export const CLEAR_ORGANIZATION = 'CLEAR_ORGANIZATION';
export const CLEAR_ORGANIZATION_SUBMISSION = 'CLEAR_ORGANIZATION_SUBMISSION';
